import RegionRouterStore from 'features/main/RegionRouterStore'
import AuthStore from 'auth/AuthStore'
import { orgContextCache } from 'cache/orgContextCache'
import { apiClientSilent } from 'api/trpc/trpc-client'

interface AuthValidateLinkBelongsToUserStoreParams {
   authStore: AuthStore
   regionRouterStore: RegionRouterStore
   userId: string
   redirectUrl: string
}

export default class AuthValidateLinkBelongsToUserStore {
   sp

   constructor(sp: AuthValidateLinkBelongsToUserStoreParams) {
      this.sp = sp
   }

   validateUserFromEmailLinkAndRedirect = async () => {
      const validated = await this.sp.authStore.validateUserFromEmailLink(this.sp.userId)

      const splitRoute = this.sp.redirectUrl.split('/')
      let orgId = splitRoute[1]

      // In some cases splitted route is as ['', 'org', 'HFAKJDFH01234567'], so try and ammend
      if (orgId === 'org') {
         orgId = splitRoute[2]
      }

      if (!validated) {
         await this.sp.authStore.signOut()
      } else {
         // Try to authenticate against requested org
         try {
            orgContextCache.authOrgId.set(orgId)
            const userInfo = await apiClientSilent.user.getMyUserInfo.query()
            if (userInfo?.userOrg?.orgId !== orgId) {
               // If the userOrg is set but orgId is different, it means we dont have access to this org
               await this.sp.authStore.signOut()
            }
         } catch {
            // Regardless of the error, sign out
            await this.sp.authStore.signOut()
         }
      }

      this.sp.regionRouterStore.navigate(`${this.sp.redirectUrl}`)
   }
}
